const mapValue = function (_val, _min1, _max1, _min2, _max2) {
    return _min2 + (_max2 - _min2) * ((_val - _min1) / (_max1 - _min1));
};

export default mapValue;
